"use client";

import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";
import {
    SectionShell,
    EditorialTitle,
    GradientText,
    RevealOnScroll,
} from "@/components/ui/Socials/JoinInstructors/_primitives";

// Le système au-delà de la prise d'appel : un poste de pilotage des relations.
// Cartes menées par une icône (Solar) pour se distinguer des cartes numérotées
// de la section Proposition.
const FEATURES = [
    { key: "availability", icon: "calendar-linear" },
    { key: "sync", icon: "calendar-mark-linear" },
    { key: "preview", icon: "eye-linear" },
    { key: "contacts", icon: "users-group-rounded-linear" },
    { key: "discovery", icon: "gift-linear" },
    { key: "hub", icon: "widget-5-linear" },
];

export default function SystemSection() {
    const t = useTranslations();

    return (
        <SectionShell label={t("joinMentor_system_marker")}>
            <div className="grid lg:grid-cols-3 gap-8 sm:gap-10 items-end mb-10 sm:mb-14">
                <RevealOnScroll className="lg:col-span-2">
                    <p className="text-[11px] uppercase tracking-[0.28em] text-primary mb-6">
                        {t("joinMentor_system_eyebrow")}
                    </p>
                    <EditorialTitle className="text-4xl sm:text-5xl md:text-7xl">
                        {t("joinMentor_system_title_part1")}
                        <br />
                        <GradientText>
                            {t("joinMentor_system_title_emphasis")}
                        </GradientText>
                    </EditorialTitle>
                </RevealOnScroll>
                <RevealOnScroll delay={0.1}>
                    <p
                        className="mb-0 text-gray-500 dark:text-white/55 italic text-base sm:text-lg"
                        style={{
                            fontFamily: "'Playfair Display', Georgia, serif",
                        }}
                    >
                        {t("joinMentor_system_subtitle_part1")}{" "}
                        <span className="text-gray-900 dark:text-white not-italic font-semibold">
                            {t("joinMentor_system_subtitle_emphasis")}
                        </span>
                        {t("joinMentor_system_subtitle_part2")}
                    </p>
                </RevealOnScroll>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {FEATURES.map((feature, idx) => (
                    <RevealOnScroll key={feature.key} delay={idx * 0.06}>
                        <div className="h-full rounded-2xl border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-white/[0.03] p-7 flex flex-col">
                            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-white dark:bg-[#0E161D] border border-gray-200 dark:border-white/10 text-primary mb-5">
                                <SolarIcon
                                    name={feature.icon}
                                    className="text-xl"
                                />
                            </span>
                            <h3
                                className="text-xl font-bold mb-3 leading-tight text-gray-900 dark:text-white"
                                style={{
                                    fontFamily:
                                        "'Playfair Display', Georgia, serif",
                                }}
                            >
                                {t(`joinMentor_system_${feature.key}_title`)}
                            </h3>
                            <p className="mb-0 text-sm leading-relaxed text-gray-600 dark:text-white/70">
                                {t(`joinMentor_system_${feature.key}_desc`)}
                            </p>
                        </div>
                    </RevealOnScroll>
                ))}
            </div>

            <RevealOnScroll delay={0.4}>
                <p
                    className="mt-10 text-center italic text-gray-600 dark:text-white/70 max-w-3xl mx-auto"
                    style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
                >
                    {t("joinMentor_system_footer_part1")}{" "}
                    <span className="text-primary font-semibold not-italic">
                        {t("joinMentor_system_footer_emphasis")}
                    </span>
                    {t("joinMentor_system_footer_part2")}
                </p>
            </RevealOnScroll>
        </SectionShell>
    );
}
